import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import DatePicker from 'components/organisms/DatePicker'
import CheckboxInput from 'components/molecules/CheckboxInput'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

import { GROUP_DATA, TRAP_DATA } from 'constants/form'

const styles = theme => ({
  root: {},
  input: {
    width: 500,
  },
  inputSection: {
    padding: `${theme.spacing(2)}px 0`,
  },
  submitButtonContainer: {
    textAlign: 'right',
    marginTop: theme.spacing(2),
  },
  dateRange: {
    width: 500,
    marginRight: 'auto',
  },
})

// NOTE: Done a quick and dirty repurposing of this unused popup, so names aren't what they should be

const ExportDataForm = ({
                          type,
                          classes,
                          endDate,
                          startDate,
                          setEndDate,
                          setStartDate,
                          onExportClick,
                          setExportType,
}) => (
  <div className={classes.root}>
    <Typography variant="h1">Choose data to export</Typography>
    <section className={classes.inputSection}>
      <CheckboxInput
          value={GROUP_DATA}
          onClick={setExportType}
          className={classes.input}
          active={type === GROUP_DATA}
          text="Summary data (last 12 months)"
      />
      <CheckboxInput
          value={TRAP_DATA}
          onClick={setExportType}
          className={classes.input}
          active={type === TRAP_DATA}
          text="Kill data (all  time)"
      />
    </section>
    {/*
    <Grid
      container
      alignItems="center"
      justify="space-between"
      className={classNames(classes.inputSection, classes.dateRange)}>
      <Grid item>
        <Typography variant="body1">Date range: </Typography>
      </Grid>
      <DatePicker
        key="startDate"
        value={startDate}
        maxDate={endDate}
        label="Start Date"
        onChange={setStartDate}
      />
      <DatePicker
        key="endDate"
        value={endDate}
        label="End date"
        minDate={startDate}
        onChange={setEndDate}
      />
    </Grid>
    */}
    <div className={classes.submitButtonContainer}>
      <SubmitButton
        autoFocus
        size="medium"
        type="submit"
        color="primary"
        variant="primary"
        onClick={onExportClick}>
          Export
      </SubmitButton>
    </div>
  </div>
)

ExportDataForm.propTypes = {
  type: PropTypes.string,
  classes: PropTypes.object,
  setEndDate: PropTypes.func,
  setStartDate: PropTypes.func,
  setExportType: PropTypes.func,
  onExportClick: PropTypes.func,
  endDate: PropTypes.instanceOf(Date),
  startDate: PropTypes.instanceOf(Date),
}

export default withStyles(styles)(ExportDataForm)



// WEBPACK FOOTER //
// ./src/components/organisms/ExportDataForm/ExportDataForm.js